import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatNumber, formatMoney } from '../utils'

export const globalDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'sum',
      field: 'installs_quantity',
      headerName: 'Installs',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'total_spent',
      headerName: 'Total Spent',
      sort: 'desc',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'extrapolationAvg',
      field: 'extrapolation',
      headerName: 'Extrapolation',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'cpiAvg',
      field: 'cpi',
      headerName: 'CPI',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'greyFill',
  headerName: 'Global',
}
